export function formatCurrency(price, options = { compact: false }) {
  let formatter = Intl.NumberFormat('en-US', {
    notation: options['compact'] ? 'compact' : 'standard',
    maximumFractionDigits: 2
  });
  return formatter.format(price);
}

export function toQuarter(date) {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return `Q${Math.floor(date.getMonth() / 3) + 1} ${date.getFullYear()}`;
}

export function toYear(date) {
  if (typeof date === 'string') {
    date = new Date(date);
  }
  return date.getFullYear();
}